import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Alert, 
  AlertTitle,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { getLatestLoginsForSalesOrg } from "../../utils/GetAdmin";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import {checkForRole} from "../../utils/GetAuth";
import LockIcon from '@mui/icons-material/Lock';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    primary: {
      marginTop: theme.spacing(2),
    },
  })
);

const SalesOrgLookup: any = {
  "4100": "CCBCU",
  "4200": "CCCi",
  "4400": "SWIRE",
  "4500": "CCBF",
  "4600": "REYES",
  "4700": "HCCBC",
  "4800": "CCSWB",
  "4900": "ABARTA",
  "5000": "CCBN",
  "5200": "LCCB",
  "5300": "CCBL",
} as const;

export default function ComAdminLatestLogin() {
  const classes = useStyles();
  const [latestLogins, SetLatestLogins] = useState<any[]>([]);
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const enabled = checkForRole(clientId,salesOrg,'vp_admin')||checkForRole(clientId,salesOrg,'vs_admin');
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
  
  const header =  document.querySelector('ResponsiveDrawer')
  const headerAdj = header?header.clientHeight:250;
  const [TABLE_BODY_HEIGHT, setTABLE_BODY_HEIGHT] = React.useState<string>(`${window.innerHeight - headerAdj }px`);

  window.addEventListener('resize', ()=>{
    setTABLE_BODY_HEIGHT(`${window.innerHeight - headerAdj }px`);
  });



  useEffect(() => {
    if (doneLoading) {
      return;
    }
    const salesOrgName: string = SalesOrgLookup[salesOrg];
    getLatestLoginsForSalesOrg(salesOrg, salesOrgName).then((v) => {
      setDoneLoading(true);
      if(v){
        SetLatestLogins(v.latestLogins);
      }
    });
  }, [doneLoading, latestLogins, salesOrg]);


  return (
    <div className={classes.root}>
      {doneLoading && enabled? (
        <div>
            <TableAbstraction
            settingsKey="ADM_SALL"
              options={{
                draggableColumns: {
                  enabled: true,
                },
                rowsPerPageOptions: [25, 50, 100],
                tableBodyHeight: TABLE_BODY_HEIGHT,
                serverSide: false,
                selectableRows: "none",
                rowsPerPage: muiTable.rpp,
                onChangeRowsPerPage: (numberOfRows) => {
                  muiTable.rpp = numberOfRows;
                  setMuiTable(muiTable);
                },
              }}
              title="Last Logins"
              columns={[
                {
                  label: "User Name",
                  name: "user_name",
                  options: {
                    searchable: true,
                    filter: true,
                  },
                },
                {
                  label: "Name",
                  name: "name",
                  options: {
                    searchable: true,
                    filter: true,
                  },
                },
                {
                  label: "Last Login",
                  name: "login_dt",
                  options: {
                    searchable: true,
                    filter: true,
                  },
                },
                {
                  label: "Groups",
                  name: "roles",
                  options: {
                    searchable: true,
                    filter: true,
                  },
                },
                {
                  label: "Sales Office",
                  name: "sales_office",
                  options: {
                    filter: true,
                    customBodyRender: (value: any) =>
                    value === '*' ? 'All' :`${value}` ,
                  },
                },
                {
                  label: "Delivery Plant",
                  name: "delivery_plant",
                  options: {
                    filter: true,
                    customBodyRender: (value: any) =>
                    value === '*' ? 'All' :`${value}` ,
                  },
                },
              ]}
              data={latestLogins}
            />
        </div>
      ) : ( enabled ? (
        <div className={classes.centerDiv}>
          <CircularProgress color="primary" />
        </div>) : (
          <Alert severity="error">
            <AlertTitle><LockIcon/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Security Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
        )
      )}
    </div>
  );
}